import { useApi } from '../hooks/useApi'
import { formatTimestamp } from '../utils/formatters'
import type { TripLogFile } from '../types'
import './TripLogs.css'

function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(1)} GB`
}

export function TripLogsPage() {
  const { data: files, loading, error } = useApi<TripLogFile[]>('/api/v1/vehicle/trip-logs')

  return (
    <div className="trip-logs">
      <h1>Trip Logs</h1>
      <p className="subtitle">CSV sensor logs uploaded from VanDash</p>

      {loading && <div className="status-message">Loading...</div>}
      {error && <div className="error-message">{error}</div>}

      {!loading && !error && files && files.length === 0 && (
        <p className="empty-message">No log files uploaded yet.</p>
      )}

      {files && files.length > 0 && (
        <div className="log-table-wrapper">
          <table className="log-table">
            <thead>
              <tr>
                <th>File</th>
                <th>Size</th>
                <th>Uploaded</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {files.map((file) => (
                <tr key={file.name}>
                  <td className="file-name">{file.name}</td>
                  <td className="file-size">{formatFileSize(file.size)}</td>
                  <td className="file-date">{formatTimestamp(file.last_modified)}</td>
                  <td>
                    <a
                      href={`/api/v1/vehicle/trip-logs/${encodeURIComponent(file.name)}`}
                      className="download-link"
                    >
                      Download
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
